import React from 'react'
import parser from 'html-react-parser'

export default function HeroThanks({data}) {
    const {heroThanksSubtitle, heroThanksTitle, heroThanksDesktopImage, heroThanksMobileImage} = data
    return (
        <div
            className='inner-banner d-thankyou-hero  font-white'
            style={{
                background: `url(${heroThanksDesktopImage?.localFile?.publicURL}) left top no-repeat`,
            }}
        >
            <div
                className='inner-mobile-hero-bg'
                style={{
                    background: `url(${heroThanksMobileImage?.localFile?.publicURL}) center top no-repeat`,
                }}
            ></div>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1 className='font-size-120 text-center'>{heroThanksTitle && parser(heroThanksTitle)}</h1>
                        <h2 className='font-size-80 text-center'>{heroThanksSubtitle && parser(heroThanksSubtitle)}</h2>
                    </div>
                </div>
            </div>
        </div>
    )
}
